import { useEffect, useRef } from "react";
import NavigationRoutes from "../components/NavigationRoutes.tsx";
import "../store/globalStore.ts";
import { scormU } from "../util/scorm/scormUnified.ts";
import {
  globalStore$,
  saveStoreToLMS,
  hydrateFromSCORM,
} from "../store/globalStore.ts";

// Restore the cover-dismissed flag from the browser session before the first render.
if (sessionStorage.getItem("hasStarted") === "true") {
  globalStore$.hasStarted.set(true);
}

export function App() {
  console.log("project-version: 2026-01-12 09:21");
  const scormInitialized = useRef(false);

  useEffect(() => {
    // Evitar re-inicialización en React Strict Mode
    if (scormInitialized.current) {
      console.log("[SCORM] Ya inicializado, saltando re-init");
      return;
    }

    console.log("[SCORM] Inicializando conexión SCORM...");
    const initSuccess = scormU.init({
      autoTrackTime: true,
      saveTimeOnSave: true,
    });

    if (!initSuccess) {
      console.error(
        "[SCORM] ✗ Fallo al inicializar SCORM, usando estado inicial",
      );
      return;
    }

    console.log("[SCORM] ✓ Conexión SCORM inicializada correctamente");
    scormInitialized.current = true;

    // Hidratar usando la lógica centralizada en el store
    hydrateFromSCORM();

    // Handler para visibilitychange (cuando se cambia de pestaña o se minimiza)
    const handleVisibilityChange = () => {
      if (document.hidden && scormU.isConnected()) {
        console.log("[SCORM] Pestaña oculta: Guardando datos...");
        saveStoreToLMS();
      }
    };

    // Registrar event listener solo para visibility
    // NOTA: El manejo de beforeunload/unload ahora es global en main.tsx
    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Cleanup
    return () => {
      console.log("[SCORM] Cleanup: Removiendo event listeners");
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  return <NavigationRoutes />;
}
